import React from 'react';

import verizonLogo from './Verizon-logo.svg';

export const VerizonAsurionLogo: React.FC<{'data-testid'?: string}> = (props) => (
  <img src={verizonLogo} alt="Verizon" data-testid={props["data-testid"]}/>
);
